(function () {
  'use strict';

  function stars(rating) {
    var n = Math.round(Number(rating) || 5);
    var out = '';
    for (var i = 0; i < 5; i++) out += i < n ? '★' : '☆';
    return out;
  }

  function reviewImage(review) {
    if (!review || !review.media) return '';
    for (var i = 0; i < review.media.length; i++) {
      var item = review.media[i];
      if (item && item.url && (item.type === 'image' || item.type === 'photo')) return item.url;
    }
    return '';
  }

  function cardHtml(review) {
    var img = reviewImage(review);
    var name = (review.reviewer && review.reviewer.name) || 'Zweryfikowany zakup';
    var quote = review.body || '';
  return (
      '<article class="home-tcard">' +
        '<div class="home-tcard__photo">' +
          (img
            ? '<img src="' + img + '" alt="' + name.replace(/"/g, '&quot;') + '" width="400" height="260" loading="lazy">'
            : '') +
        '</div>' +
        '<div class="home-tcard__body">' +
          '<span class="home-tcard__stars" aria-hidden="true">' + stars(review.rating) + '</span>' +
          '<p class="home-tcard__quote">' + quote + '</p>' +
          '<div class="home-tcard__meta">' +
            '<span class="home-tcard__name">' + name + '</span>' +
            (review.verified ? '<span class="home-tcard__verified">✓ Zweryfikowany zakup</span>' : '') +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function renderReviews(section, reviews) {
    var grid = section.querySelector('[data-loox-grid]');
    if (!grid) return;
    grid.innerHTML = reviews.map(cardHtml).join('');
    section.classList.add('is-loox-loaded');
  }

  function fetchReviews(storeId, productId, limit) {
    var base = 'https://storefront-api.loox.io/storefront/v1/store/' + encodeURIComponent(storeId);
    var path = productId ? '/product-reviews' : '/store-reviews';
    var url = new URL(base + path);
    url.searchParams.set('limit', String(Math.max(limit * 4, 12)));
    url.searchParams.set('sort', 'featured');
    if (productId) url.searchParams.set('product_id', productId);
    return fetch(url.toString()).then(function (res) {
      if (!res.ok) throw new Error('Loox API ' + res.status);
      return res.json();
    });
  }

  function initSection(section) {
    var storeId = section.dataset.looxStoreId;
    if (!storeId) return;

    var productId = section.dataset.looxProductId || '';
    var limit = parseInt(section.dataset.looxLimit || '3', 10);
    var manifestUrl = section.dataset.looxManifest;

    function applyList(list) {
      var withPhotos = list.filter(function (r) { return reviewImage(r); });
      if (!withPhotos.length) withPhotos = list;
      renderReviews(section, withPhotos.slice(0, limit));
    }

    if (manifestUrl) {
      fetch(manifestUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.reviews && data.reviews.length) {
            applyList(data.reviews);
            return null;
          }
          return fetchReviews(storeId, productId, limit);
        })
        .then(function (data) {
          if (data && data.reviews) applyList(data.reviews);
        })
        .catch(function () {
          fetchReviews(storeId, productId, limit)
            .then(function (data) { applyList(data.reviews || []); })
            .catch(function () {});
        });
      return;
    }

    fetchReviews(storeId, productId, limit)
      .then(function (data) { applyList(data.reviews || []); })
      .catch(function () {});
  }

  document.querySelectorAll('[data-loox-testimonials]').forEach(initSection);
})();
